export class CreateOrUpdateActionException extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'CreateOrUpdateActionException';

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, CreateOrUpdateActionException);
    }
  }
}
